export enum PreorderStatus {
  PENDING_INITIAL = 'PENDING_INITIAL',
  PENDING_WAITING_FOR_PAYMENT = 'PENDING_WAITING_FOR_PAYMENT',
  PENDING_PAID = 'PENDING_PAID',

  SUBMITTED_PROFIPAY_NEW = 'SUBMITTED_PROFIPAY_NEW',
  SUBMITTED_PROFIPAY_INPROGRESS = 'SUBMITTED_PROFIPAY_INPROGRESS',
  SUBMITTED_PROFIPAY_READYFORPICKUP = 'SUBMITTED_PROFIPAY_READYFORPICKUP',
  SUBMITTED_PROFIPAY_READYFORPICKUP_INCOMPLETE = 'SUBMITTED_PROFIPAY_READYFORPICKUP_INCOMPLETE',
  SUBMITTED_PROFIPAY_SUSPENDED = 'SUBMITTED_PROFIPAY_SUSPENDED',

  COMPLETED_PROFIPAY_PICKEDUP = 'COMPLETED_PROFIPAY_PICKEDUP',

  ERROR_UNKNOWN = 'ERROR_UNKNOWN',
  ERROR_PAYMENT = 'ERROR_PAYMENT',
  ERROR_EXPIRED = 'ERROR_EXPIRED',
  ERROR_PROFIPAY_VALIDATION = 'ERROR_PROFIPAY_VALIDATION',
}
